// Formata um Date em YYYY-MM-DD usando os componentes LOCAIS (getFullYear/
// getMonth/getDate) — não UTC. `d.toISOString().slice(0, 10)` desloca a data
// conforme o horário do dia + timezone do navegador (ex: à noite no Brasil,
// já ~3h à frente em UTC, uma data calculada assim adianta um dia).
export function dateToLocalISO(d) {
  const y = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${mo}-${day}`;
}

// Data local de hoje em YYYY-MM-DD. Usar sempre no lugar de
// `new Date().toISOString().slice(0, 10)` / `.split("T")[0]` pra qualquer
// "data de hoje" que vai pro backend ou é o maxDate de um date picker.
export function todayLocalISO() {
  return dateToLocalISO(new Date());
}

export function formatChatTime(dateString) {
    const iso = dateString.endsWith("Z") ? dateString : `${dateString}Z`;
    const date = new Date(iso);
  
    const now = new Date();
  
    const isToday =
      date.toDateString() === now.toDateString();
  
    const yesterday = new Date();
    yesterday.setDate(now.getDate() - 1);
  
    const isYesterday =
      date.toDateString() === yesterday.toDateString();
  
    const time = new Intl.DateTimeFormat("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "America/Sao_Paulo",
    }).format(date);
  
    if (isToday) return `Hoje ${time}`;
    if (isYesterday) return `Ontem ${time}`;
  
    const day = new Intl.DateTimeFormat("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      timeZone: "America/Sao_Paulo",
    }).format(date);
  
    return `${day} ${time}`;
  }

  // Converte strings sem timezone em datas locais, evitando deslocamento UTC
  export function toLocalDate(input) {
    if (!input) return new Date();
    if (input instanceof Date) return new Date(input.getTime());
    if (typeof input === 'number') return new Date(input);
    const s = String(input).trim();
    // Se possuir timezone explícito (Z ou ±hh:mm), delega ao parser nativo
    if (/[zZ]|[+-]\d{2}:?\d{2}$/.test(s)) return new Date(s);
    // Divide data e hora, tratando como horário local
    const [datePart, timePart = ''] = s.split(/[T\s]/);
    const [y, m, d] = datePart.split('-').map((v) => parseInt(v, 10));
    if (!y || !m || !d) return new Date(s);
    if (timePart) {
      const [hh = '0', mm = '0', ss = '0'] = timePart.split(':');
      return new Date(y, m - 1, d, parseInt(hh, 10) || 0, parseInt(mm, 10) || 0, parseInt(ss, 10) || 0);
    }
    return new Date(y, m - 1, d);
  }

  // Início da semana na segunda-feira (horário local)
  export function startOfWeek(date) {
    const d = new Date(date);
    const day = (d.getDay() + 6) % 7; // Monday=0
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() - day);
    return d;
  }

  // Formata rótulo curto da semana: dd/MM (usando horário local)
  // toLocalDate() evita offset UTC ao receber strings YYYY-MM-DD
  export function formatWeekLabel(date) {
    const dt = toLocalDate(date);
    const month = String(dt.getMonth() + 1).padStart(2, '0');
    const day = String(dt.getDate()).padStart(2, '0');
    return `${day}/${month}`;
  }